/**
 * FERP Portal - Regulatory Status Configuration (DRR-058)
 *
 * Centralized UI configuration for regulatory rule statuses, review queues,
 * and safety badge styling.
 *
 * The frontend is DUMB - it only provides UI styling for backend-defined values.
 *
 * Source of truth: backend GraphQL schema
 * Generated types: generated/graphql.ts
 */

import {
  GqlRuleStatus,
  GqlReviewQueue,
  GqlSafetyLevel,
} from '@/generated/graphql';

export const SAFETY_BADGE_CONFIG: Record<string, { color: string; label: string }> = {
  [GqlSafetyLevel.CRITICAL]: { color: 'red', label: 'CRITICAL' },
  [GqlSafetyLevel.HIGH]: { color: 'orange', label: 'HIGH' },
  [GqlSafetyLevel.STANDARD]: { color: 'blue', label: 'STANDARD' },
  [GqlSafetyLevel.LOW]: { color: 'gray', label: 'LOW' },
};

export const RULE_STATUS_BADGE_CONFIG: Record<string, { color: string; label: string }> = {
  [GqlRuleStatus.PENDING_REVIEW]: { color: 'yellow', label: 'Pending' },
  [GqlRuleStatus.IN_REVIEW]: { color: 'blue', label: 'In Review' },
  [GqlRuleStatus.APPROVED]: { color: 'green', label: 'Approved' },
  [GqlRuleStatus.REJECTED]: { color: 'red', label: 'Rejected' },
  [GqlRuleStatus.SUPERSEDED]: { color: 'gray', label: 'Superseded' },
  [GqlRuleStatus.EXPIRED]: { color: 'gray', label: 'Expired' },
};

export const REVIEW_QUEUE_BADGE_CONFIG: Record<string, { color: string; label: string }> = {
  [GqlReviewQueue.AUTO]: { color: 'green', label: 'Auto' },
  [GqlReviewQueue.CONFIDENCE]: { color: 'yellow', label: 'Confidence' },
  [GqlReviewQueue.CONFLICT]: { color: 'orange', label: 'Conflict' },
  [GqlReviewQueue.SAFETY]: { color: 'red', label: 'Safety' },
};
